import React, { useState, useEffect } from 'react';
import {
  BarChart3, TrendingUp, TrendingDown, Target, Award, Users, 
  Clock, CheckCircle, AlertTriangle, Eye, Download, Settings,
  Plus, Filter, Calendar, RefreshCw, Zap, Star, Activity,
  PieChart, LineChart, BarChart, Gauge, Thermometer, 
  ChevronUp, ChevronDown, MoreHorizontal, ExternalLink,
  MessageSquare, FileText, BookOpen, Timer, Save, Send,
  FilePlus, Tag, Flag, Layers, Grid, List, MoreVertical,
  ThumbsUp, ThumbsDown, Folder, User, Mail, Phone, MapPin,
  Globe, Key, Smartphone, EyeOff, Bell, Lock, Unlock,
  Shield, Info, HelpCircle, X, Check, Minus, Play, Pause,
  RotateCcw, Paperclip, Archive, Copy, Share2, Trash2,
  Edit, Search, ChevronRight, ChevronLeft, Maximize2,
  Minimize2, Move, RotateCw, Wifi, WifiOff, Signal,
  Battery, BatteryLow, Volume2, VolumeX, Mic, MicOff,
  Camera, CameraOff, Video, VideoOff, Headphones,
  HeadphonesOff, Monitor, MonitorOff, Laptop, Smartphone as PhoneIcon,
  Tablet, Watch, Tv, Gamepad2, Mouse, Keyboard, Printer,
  Scanner, HardDrive, Cpu, MemoryStick, Database, Server,
  Cloud, CloudOff, Upload, Download as DownloadIcon,
  Link, LinkOff, Share, ShareOff, Lock as LockIcon,
  Unlock as UnlockIcon, Key as KeyIcon, Fingerprint,
  Shield as ShieldIcon, ShieldCheck, ShieldAlert,
  AlertCircle, AlertTriangle as AlertTriangleIcon,
  Info as InfoIcon, HelpCircle as HelpCircleIcon,
  CheckCircle as CheckCircleIcon, XCircle, MinusCircle,
  PlusCircle, PlayCircle, PauseCircle, StopCircle,
  SkipBack, SkipForward, Rewind, FastForward, Repeat,
  Shuffle, Volume1, Volume2 as Volume2Icon, VolumeX as VolumeXIcon,
  Mic as MicIcon, MicOff as MicOffIcon, Camera as CameraIcon,
  CameraOff as CameraOffIcon, Video as VideoIcon, VideoOff as VideoOffIcon,
  Headphones as HeadphonesIcon, HeadphonesOff as HeadphonesOffIcon,
  Monitor as MonitorIcon, MonitorOff as MonitorOffIcon,
  Laptop as LaptopIcon, Tablet as TabletIcon, Watch as WatchIcon,
  Tv as TvIcon, Gamepad2 as Gamepad2Icon, Mouse as MouseIcon,
  Keyboard as KeyboardIcon, Printer as PrinterIcon,
  Scanner as ScannerIcon, HardDrive as HardDriveIcon,
  Cpu as CpuIcon, MemoryStick as MemoryStickIcon,
  Database as DatabaseIcon, Server as ServerIcon,
  Cloud as CloudIcon, CloudOff as CloudOffIcon,
  Upload as UploadIcon, Link as LinkIcon, LinkOff as LinkOffIcon,
  Share as ShareIcon, ShareOff as ShareOffIcon,
  Fingerprint as FingerprintIcon, ShieldCheck as ShieldCheckIcon,
  ShieldAlert as ShieldAlertIcon, AlertCircle as AlertCircleIcon,
  XCircle as XCircleIcon, MinusCircle as MinusCircleIcon,
  PlusCircle as PlusCircleIcon, PlayCircle as PlayCircleIcon,
  PauseCircle as PauseCircleIcon, StopCircle as StopCircleIcon,
  SkipBack as SkipBackIcon, SkipForward as SkipForwardIcon,
  Rewind as RewindIcon, FastForward as FastForwardIcon,
  Repeat as RepeatIcon, Shuffle as ShuffleIcon,
  Volume1 as Volume1Icon, Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon, Signal as SignalIcon,
  Wifi as WifiIcon, WifiOff as WifiOffIcon,
  Maximize2 as Maximize2Icon, Minimize2 as Minimize2Icon,
  Move as MoveIcon, RotateCw as RotateCwIcon
} from 'lucide-react';
import MockDataService from '../../../services/MockDataService';

const AgentAdvancedAnalytics = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [timeRange, setTimeRange] = useState('30d');
  const [selectedMetric, setSelectedMetric] = useState('all');

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      try {
        setLoading(true);
        const response = await MockDataService.getAgentAdvancedAnalytics('agent-001');
        if (response.success) {
          setAnalyticsData(response.data);
        } else {
          setError('Failed to load analytics data');
        }
      } catch (err) {
        setError('An error occurred while fetching analytics data.');
        console.error('Error fetching analytics data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalyticsData();
  }, []);

  if (loading) {
    return <div className="p-6 text-center text-gray-500 dark:text-gray-400">Loading advanced analytics...</div>;
  }

  if (error) {
    return <div className="p-6 text-center text-red-500 dark:text-red-400">Error: {error}</div>;
  }

  if (!analyticsData) {
    return <div className="p-6 text-center text-gray-500 dark:text-gray-400">No analytics data available.</div>;
  }

  const { agentAdvancedAnalytics, analyticsStats } = analyticsData;
  const { performanceAnalytics, trendAnalysis, comparativeAnalytics, predictiveInsights, customDashboards, dataExport, realTimeMetrics, goalTracking } = agentAdvancedAnalytics;

  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent': return 'text-green-600 dark:text-green-400';
      case 'good': return 'text-blue-600 dark:text-blue-400';
      case 'average': return 'text-yellow-600 dark:text-yellow-400';
      case 'poor': return 'text-red-600 dark:text-red-400';
      default: return 'text-gray-600 dark:text-gray-400';
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'excellent': return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
      case 'good': return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
      case 'average': return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
      case 'poor': return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
      default: return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
    }
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up': return <TrendingUp className="h-4 w-4 text-green-600 dark:text-green-400" />;
      case 'down': return <TrendingDown className="h-4 w-4 text-red-600 dark:text-red-400" />;
      case 'stable': return <Activity className="h-4 w-4 text-gray-600 dark:text-gray-400" />;
      default: return <Activity className="h-4 w-4 text-gray-600 dark:text-gray-400" />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <BarChart3 className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                  Advanced Analytics
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Performance insights and predictive analytics
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors">
                <Plus className="h-4 w-4 inline-block mr-2" />
                Custom Dashboard
              </button>
              <button className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors">
                <Download className="h-4 w-4 inline-block mr-2" />
                Export Data
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Performance Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Tickets Resolved</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{performanceAnalytics.overview.ticketsResolved}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">This month</p>
              </div>
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <CheckCircle className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Avg Resolve Time</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{performanceAnalytics.overview.averageResolveTime}h</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">Target: 2.0h</p>
              </div>
              <div className="p-2 bg-green-100 dark:bg-green-900 rounded-lg">
                <Clock className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">SLA Met</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{performanceAnalytics.overview.slaMet}%</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">Target: 95%</p>
              </div>
              <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg">
                <Target className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Customer Rating</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{performanceAnalytics.overview.customerRating}/5</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">Target: 4.5</p>
              </div>
              <div className="p-2 bg-yellow-100 dark:bg-yellow-900 rounded-lg">
                <Star className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Productivity Score</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{performanceAnalytics.overview.productivityScore}%</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">Target: 90%</p>
              </div>
              <div className="p-2 bg-indigo-100 dark:bg-indigo-900 rounded-lg">
                <Zap className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
              </div>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 mb-8">
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="flex space-x-8 px-6">
              {[
                { id: 'overview', name: 'Overview', icon: BarChart3 },
                { id: 'trends', name: 'Trends', icon: TrendingUp },
                { id: 'comparison', name: 'Team Comparison', icon: Users },
                { id: 'insights', name: 'Predictive Insights', icon: Zap },
                { id: 'goals', name: 'Goals', icon: Target },
                { id: 'realtime', name: 'Real-time', icon: Activity }
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                  }`}
                >
                  <tab.icon className="h-4 w-4 inline-block mr-2" />
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {/* Overview Tab */}
            {activeTab === 'overview' && (
              <div className="space-y-6">
                {/* Detailed Metrics */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Detailed Metrics</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {performanceAnalytics.detailedMetrics.map((metric) => (
                      <div key={metric.id} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{metric.name}</h4>
                          <div className="flex items-center space-x-2">
                            {getTrendIcon(metric.trend)}
                            <span className={`text-sm font-medium ${getStatusColor(metric.status)}`}>
                              {metric.status}
                            </span>
                          </div>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Current:</span>
                            <span className="text-lg font-bold text-gray-900 dark:text-gray-100">
                              {metric.value} {metric.unit}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Target:</span>
                            <span className="text-sm text-gray-900 dark:text-gray-100">
                              {metric.target} {metric.unit}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Change:</span>
                            <span className={`text-sm font-medium ${metric.changePercentage >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
                              {metric.changePercentage >= 0 ? '+' : ''}{metric.changePercentage}%
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* KPIs */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Key Performance Indicators</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {performanceAnalytics.kpis.map((kpi) => (
                      <div key={kpi.id} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{kpi.name}</h4>
                          <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                            kpi.status === 'exceeded' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                            kpi.status === 'met' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
                            'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
                          }`}>
                            {kpi.status}
                          </span>
                        </div>
                        <div className="space-y-2">
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Current:</span>
                            <span className="text-lg font-bold text-gray-900 dark:text-gray-100">{kpi.value}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Target:</span>
                            <span className="text-sm text-gray-900 dark:text-gray-100">{kpi.target}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Trend:</span>
                            <div className="flex items-center">
                              {getTrendIcon(kpi.trend)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Trends Tab */}
            {activeTab === 'trends' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Performance Trends</h3>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {trendAnalysis.trends.map((trend) => (
                    <div key={trend.id} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{trend.name}</h4>
                        <div className="flex items-center space-x-2">
                          {getTrendIcon(trend.trend)}
                          <span className={`text-sm font-medium ${
                            trend.trend === 'increasing' ? 'text-green-600 dark:text-green-400' :
                            trend.trend === 'decreasing' ? 'text-red-600 dark:text-red-400' :
                            'text-gray-600 dark:text-gray-400'
                          }`}>
                            {trend.trend}
                          </span>
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Correlation:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">{trend.correlation}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Significance:</span>
                          <span className={`text-sm font-medium ${
                            trend.significance === 'high' ? 'text-red-600 dark:text-red-400' :
                            trend.significance === 'medium' ? 'text-yellow-600 dark:text-yellow-400' :
                            'text-green-600 dark:text-green-400'
                          }`}>
                            {trend.significance}
                          </span>
                        </div>
                        <div className="mt-4">
                          <div className="text-sm text-gray-600 dark:text-gray-400 mb-2">Recent Data Points:</div>
                          <div className="space-y-1">
                            {trend.data.slice(-3).map((point, index) => (
                              <div key={index} className="flex justify-between text-sm">
                                <span className="text-gray-600 dark:text-gray-400">{point.label}</span>
                                <span className="text-gray-900 dark:text-gray-100">{point.value}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Team Comparison Tab */}
            {activeTab === 'comparison' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Team Comparison</h3>
                
                <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Agent</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tickets</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Avg Time</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">SLA</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Rating</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Rank</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                        {comparativeAnalytics.teamComparison.map((agent) => (
                          <tr key={agent.agentId} className={agent.agentName === 'You' ? 'bg-blue-50 dark:bg-blue-900' : ''}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="flex-shrink-0 h-10 w-10 flex items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400 text-lg font-bold">
                                  {agent.agentName.charAt(0)}
                                </div>
                                <div className="ml-4">
                                  <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{agent.agentName}</div>
                                  <div className="text-sm text-gray-500 dark:text-gray-400">Percentile: {agent.percentile}%</div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                              {agent.metrics.find(m => m.name === 'Tickets Resolved')?.value}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                              {agent.metrics.find(m => m.name === 'Average Resolve Time')?.value}h
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                              {agent.metrics.find(m => m.name === 'SLA Compliance')?.value}%
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                              {agent.metrics.find(m => m.name === 'Customer Rating')?.value}/5
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                agent.rank === 1 ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                                agent.rank === 2 ? 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200' :
                                agent.rank === 3 ? 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200' :
                                'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
                              }`}>
                                #{agent.rank}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* Predictive Insights Tab */}
            {activeTab === 'insights' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Predictive Insights</h3>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {predictiveInsights.insights.map((insight) => (
                    <div key={insight.id} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{insight.title}</h4>
                        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                          insight.impact === 'high' ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' :
                          insight.impact === 'medium' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                          'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        }`}>
                          {insight.impact} impact
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{insight.description}</p>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Confidence:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">{insight.confidence}%</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Timeframe:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">{insight.timeframe}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Actionable:</span>
                          <span className={`text-sm font-medium ${insight.actionable ? 'text-green-600 dark:text-green-400' : 'text-gray-600 dark:text-gray-400'}`}>
                            {insight.actionable ? 'Yes' : 'No'}
                          </span>
                        </div>
                      </div>
                      {insight.actions && insight.actions.length > 0 && (
                        <div className="mt-4">
                          <div className="text-sm text-gray-600 dark:text-gray-400 mb-2">Recommended Actions:</div>
                          <div className="space-y-2">
                            {insight.actions.map((action) => (
                              <div key={action.id} className="text-sm">
                                <div className="font-medium text-gray-900 dark:text-gray-100">{action.title}</div>
                                <div className="text-gray-600 dark:text-gray-400">{action.description}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Goals Tab */}
            {activeTab === 'goals' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Goal Tracking</h3>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {goalTracking.goals.map((goal) => (
                    <div key={goal.id} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{goal.name}</h4>
                        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                          goal.status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                          goal.status === 'completed' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
                          goal.status === 'paused' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                          'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
                        }`}>
                          {goal.status}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{goal.description}</p>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Current:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">{goal.current} {goal.unit}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Target:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">{goal.target} {goal.unit}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Deadline:</span>
                          <span className="text-sm text-gray-900 dark:text-gray-100">
                            {new Date(goal.deadline).toLocaleDateString()}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Priority:</span>
                          <span className={`text-sm font-medium ${
                            goal.priority === 'high' ? 'text-red-600 dark:text-red-400' :
                            goal.priority === 'medium' ? 'text-yellow-600 dark:text-yellow-400' :
                            'text-green-600 dark:text-green-400'
                          }`}>
                            {goal.priority}
                          </span>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                          <div 
                            className="bg-blue-600 h-2.5 rounded-full" 
                            style={{ width: `${(goal.current / goal.target) * 100}%` }}
                          ></div>
                        </div>
                        <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                          Progress: {((goal.current / goal.target) * 100).toFixed(1)}%
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Real-time Tab */}
            {activeTab === 'realtime' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Real-time Metrics</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {realTimeMetrics.currentMetrics.map((metric) => (
                    <div key={metric.name} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{metric.name}</h4>
                        <div className="flex items-center">
                          {getTrendIcon(metric.trend)}
                        </div>
                      </div>
                      <div className="space-y-2">
                        <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                          {metric.value} {metric.unit}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                          Last updated: {new Date(metric.timestamp).toLocaleTimeString()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6">
                  <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Live Updates</h4>
                  <div className="space-y-2">
                    {realTimeMetrics.liveUpdates.map((update) => (
                      <div key={update.id} className="flex items-center space-x-3 p-3 bg-white dark:bg-gray-800 rounded-lg">
                        <div className="flex-shrink-0">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        </div>
                        <div className="flex-1">
                          <div className="text-sm text-gray-900 dark:text-gray-100">{update.message}</div>
                          <div className="text-xs text-gray-500 dark:text-gray-400">
                            {new Date(update.timestamp).toLocaleTimeString()}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentAdvancedAnalytics;
